"use client";

import { Rss } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

interface CategoryRssButtonProps {
  rssFeedUrl: string;
  categoryName: string;
}

export default function CategoryRssButton({
  rssFeedUrl,
  categoryName,
}: CategoryRssButtonProps) {
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(rssFeedUrl)
      .then(() => {
        toast.success(`RSS feed URL for ${categoryName} copied to clipboard!`);
      })
      .catch((err) => {
        console.error("Failed to copy RSS feed URL: ", err);
        toast.error("Failed to copy RSS feed URL.");
      });
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={copyToClipboard}
      aria-label={`Copy RSS feed URL for ${categoryName}`}
      className="aspect-square"
    >
      <Rss className="h-4 w-4" />
    </Button>
  );
}
